import { GET_TESTS_DETAILS, VALIDATE_TOKEN, VALIDATE_CODE, INTITATE_TEST, TEST_DETAILS, GET_QUESTION, GET_STARTER_CODE, RUN_DATABASE_CODE, GET_NOTEBOOK_URL, SUBMIT_NOTEBOOK } from "../Types/types";

let intialState = {
    candidateDetails: null,
    testSummary: null,
    image: ''
}


export default function candidateTestReducer(state = intialState, action) {
    let stateCopy = JSON.parse(JSON.stringify(state));
    switch (action.type) {
        case GET_TESTS_DETAILS:
            stateCopy.testDetails = action.payload;
            return stateCopy;
        case VALIDATE_TOKEN:
            stateCopy.candidateDetails = action.payload.invitation;
            stateCopy.testDetails = action.payload.test;
            stateCopy.token = action.payload.token;
            stateCopy.redirectURL = action.payload.redirectURL;
            sessionStorage.setItem('token', action.payload.user.token);
            sessionStorage.setItem('email', action.payload.user.emailId);
            sessionStorage.setItem('name', action.payload.user.name);
            sessionStorage.setItem('profileDetails', JSON.stringify(action.payload.user));
            sessionStorage.setItem('role', action.payload.user.roleId);
            sessionStorage.setItem('logo', action.payload.user.logoImage);
            // localStorage.setItem('token', action.payload.token);
            sessionStorage.getItem('token') === null && window.location.reload();
            return stateCopy;
        case VALIDATE_CODE:
            return stateCopy;
        case INTITATE_TEST:
            stateCopy.candidateTestDetailId = action.payload.candidateTestDetailId;
            return stateCopy;
        case TEST_DETAILS:
            stateCopy.testSummary = action.payload;
            return stateCopy;
        case GET_QUESTION:
            stateCopy.question = action.payload.question;
            stateCopy.isTestCompleted = action.payload.isTestCompleted;
            stateCopy.isNextTest = action.payload.isNextTest;
            return stateCopy;
        case GET_STARTER_CODE:
            stateCopy.question = { ...stateCopy.question, defaultCode: action.payload };
            return stateCopy;
        case RUN_DATABASE_CODE:
            stateCopy.databaseOutput = action.payload;
            return stateCopy;
        case GET_NOTEBOOK_URL:
            stateCopy.notebookUrl = action.payload;
            return stateCopy;
        case SUBMIT_NOTEBOOK:
            return stateCopy;

        default:
            return stateCopy;
    }
}
